export class SnDetectionAttribute {
  public label: string;

  public confidence: number;
}

export class SnDetectionMetadata {
  public attributes: SnDetectionAttribute[];

  public colorBottom: SnDetectionAttribute;

  public colorTop: SnDetectionAttribute;

  public vehicleType: SnDetectionAttribute[];

  public carColor: SnDetectionAttribute[];

  public carMake: SnDetectionAttribute[];

  public getAttribute(label: string): SnDetectionAttribute {
    return this.attributes.find((a) => a.label === label);
  }
}
